export default __webpack_public_path__ + "202054f2b1c14a88b9203c5fe554cf1a.svg";